import React, { Component } from 'react';
import { useRefJs } from 'core/api/useRefJs.js';
import { loadJS } from 'core/api/loadJS.js';

const componentName = "business_component/print/print/main/index";
const url = "../../../../business_component/print/print/main/index.js";
useRefJs.setConfig({ [componentName]: url });

let PrintTemplate = useRefJs([componentName], function (Poc) {
    class PrintTemplate extends Component {
        constructor(props) {
            super(props);
        }
        render() {
            const { forwardedRef, ...rest } = this.props;
            return <Poc.PrintTemplate ref={forwardedRef} {...rest} /> 
        }
    }
    return React.forwardRef((props, ref) => {  
        return <PrintTemplate {...props} forwardedRef={ref} />;  
    });
});

export default PrintTemplate;

let print = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.print(...args);
    });
};

let printer = (...args) => {
    loadJS(url, () => {
        let res = window[componentName].default || window[componentName];
        res.printer(...args);
    });
};
export { PrintTemplate, print, printer };